export default __webpack_public_path__ + "static/media/img_eyecatch.83b1248d.jpg";